import React from 'react';
import { useRef, useEffect, useState} from 'react';
import { useInView } from 'react-intersection-observer';
import './Introduction.css';
import SelfPicture from './../../images/SelfPicture.PNG';
import SelfNoBG from './../../images/Profile-NoBG.png';
import linkedin from './../../images/linkedin.svg';
import ghub from './../../images/github.svg';
import insta from './../../images/instagram.svg';

const Introduction = () => {
    const { ref: myRef, inView: introVisible} = useInView({
        triggerOnce: true,
    });

    return(
        <div class="intro__tile" ref={myRef}>
            <div class="intro" id="home">
                <div class="intro-left">
                    <h1 class={introVisible ? "section__title section__title--intro show" : "section__title section__title--intro"}>
                        <strong>Hi! I am</strong><strong>Tam Huynh</strong>
                    </h1>
                    <p class={introVisible? "intro__subtext show" : "intro__subtext"}>
                        Backend Engineer at Capital One and University of Florida Alumnus.
                    </p>
                    <p class={introVisible? "section__subtitle section__subtitle--intro show" : "section__subtitle section__subtitle--intro"}>
                        Software Engineer @ Capital One</p>
                </div>

                <div class="intro-right">
                    <div class={introVisible ? "deco-square deco-square--filled show" : "deco-square deco-square--filled"}></div>
                    <div class={introVisible ? "deco-square deco-square--outline show" : "deco-square deco-square--outline"}></div>
                    <img src={SelfNoBG} alt="picture of self" class={introVisible?"intro__img show":"intro__img"}></img>
                    
                    <div class="floaters">
                        <a href="https://www.linkedin.com/in/tam-n-huynh/" target="_blank">
                            <img class={introVisible ? "f1 show":"f1"} src={linkedin}/>
                        </a>
                        <a href="https://github.com/tam-n-huynh" target="_blank">
                            <img class={introVisible ? "f2 show":"f2"} src={ghub}/>
                        </a>
                        <a href="" target="_blank">
                            <img class={introVisible ? "f3 show":"f3"} src={insta}/>  
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Introduction;